var _rect, _rect2, _rect3, _g, _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-421 -548)",
    fill: "#292C31"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -93,
    y: -357,
    width: 490,
    height: 779,
    rx: 40,
    fill: "#202225"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_195_1362)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -8,
    width: 335,
    height: 50,
    rx: 10,
    fill: "#B0B0B0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#292C31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3244 8.57676L24.6902 9.97042L22.1259 12.5348L19.4454 9.82176C18.698 9.06675 17.6817 8.63888 16.6193 8.63191C15.557 8.62494 14.5351 9.03945 13.7779 9.78459C13.0254 10.5324 12.5992 11.5475 12.5922 12.6084C12.5853 13.6693 12.9981 14.6898 13.7407 15.4475L17.8659 19.6285L19.622 21.4124C19.7921 21.581 19.9271 21.7817 20.0192 22.0029C20.1113 22.2241 20.1586 22.4613 20.1583 22.7009C20.1581 22.9405 20.1104 23.1776 20.0179 23.3986C19.9254 23.6196 19.79 23.8201 19.6195 23.9884C19.4491 24.1567 19.2469 24.2896 19.0247 24.3792C18.8026 24.4689 18.5648 24.5136 18.3253 24.5108C18.0857 24.508 17.8491 24.4577 17.6291 24.3628C17.4091 24.268 17.2102 24.1304 17.0437 23.9581L15.3016 22.1696L11.1764 17.9886C9.75871 16.5449 8.97063 14.5985 8.98456 12.5752C8.99849 10.5518 9.8133 8.61642 11.2507 7.19239C12.6944 5.77524 14.6402 4.9871 16.6632 5.00016C18.6861 5.01322 20.6217 5.82641 22.0469 7.26207L23.3244 8.57676Z",
    fill: "#009FBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7877 26.9364L10.4219 25.5428L12.9862 22.9785L15.6667 25.6914C16.4147 26.4453 17.4308 26.8724 18.4928 26.8794C19.5548 26.8863 20.5764 26.4726 21.3342 25.7286C22.0878 24.9814 22.5148 23.9661 22.5218 22.9048C22.5287 21.8436 22.1151 20.8228 21.3714 20.0657L17.2462 15.8847L15.4902 14.1008C15.323 13.9312 15.1909 13.7304 15.1014 13.5097C15.0118 13.2891 14.9666 13.0529 14.9684 12.8148C14.9701 12.5767 15.0187 12.3412 15.1114 12.1219C15.2041 11.9026 15.3391 11.7037 15.5087 11.5365C15.6783 11.3693 15.8792 11.2372 16.0999 11.1477C16.3205 11.0582 16.5566 11.013 16.7948 11.0147C17.0329 11.0164 17.2683 11.065 17.4877 11.1577C17.707 11.2505 17.9059 11.3855 18.0731 11.5551L19.8291 13.3343L23.9543 17.5153C25.372 18.959 26.1601 20.9054 26.1461 22.9288C26.1322 24.9521 25.3174 26.8875 23.88 28.3115C22.4363 29.7287 20.4904 30.5168 18.4675 30.5037C16.4446 30.4907 14.509 29.6775 13.0838 28.2418L11.7877 26.9364Z",
    fill: "#865DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_195_1362",
    x: -20,
    y: -8,
    width: 343,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_195_1362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_195_1362",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStc);
export default __webpack_public_path__ + "static/media/stc.b51f9da45c469ad5a37e1576cb5fe661.svg";
export { ForwardRef as ReactComponent };